<template>
  <div class="col-lg-8 mx-auto">
    <header class="text-center">
      <workflow-navigation workflowStage="Haves" />
      <h2 class="skin-page-heading">
        What you have to put towards retirement
      </h2>
      <p class="px-3">
        {{ subHeadingText }}
        <help
          title="What different parts can you put towards your retirement income?"
          :text="HelpText.AssetsHeader()"
          :isWide="true"
        />
      </p>
    </header>

    <assets />

    <page-nav backLink="requirements" @nextClicked="onNextClicked" :parent-will-handle-next="true" :next-link="nextLink" />
  </div>

  <modal
    ref="noPotsModal"
    idKey="NoPensionsWarning"
    title="No pension pots added"
  >
    <p>
      We can show you how to take money from your pension pots along with
      everything else to get what you want, we would expect you would want to
      add at least one?
    </p>
  </modal>
</template>

<script lang="ts">
import { defineComponent, ref } from "vue";
import WorkflowNavigation from "@/guiide/components/common/WorkflowNavigation.vue";
import HelpText from "@/guiide/ts/helpText";
import Help from "@/guiide/components/common/Help.vue";
import Assets from "@/guiide/components/assets/Assets.vue";
import PageNav from "@/guiide/components/common/PageNav.vue";
import Modal from "@/guiide/components/common/Modal.vue";
import { PensionPot } from "../ts/pensionPot";
import { workflow } from "../ts/workflow/workflow";
import View from "../ts/view";

export default defineComponent({
  name: "Income",
  components: {
    WorkflowNavigation,
    Help,
    Assets,
    PageNav,
    Modal
  },
  data() {
    const nextLink = ref("");

    return {
      noPotsWarningShown: false,
      nextLink
    };
  },
  setup() {
    const userCode = ref(null);
    const noPotsModal = ref(null);

    return {
      userCode,
      noPotsModal,
      HelpText
    };
  },
  async mounted() {
    const nextWorkflowStep = await workflow.getNextWorkflowStep(View.Haves);
    this.nextLink = nextWorkflowStep.resource;
  },
  computed: {
    subHeadingText: function(): string {
      return this.$store.state.configuration.havesSubHeadingText;
    }
  },
  methods: {
    onNextClicked() {
      const pensionPots =
        this.$store.state.retiree?.pensionPots.pots ?? new Array<PensionPot>();

      if (!this.noPotsWarningShown && pensionPots.length == 0) {
        this.noPotsModal.showModal();
        this.noPotsWarningShown = true;
        return;
      }

      workflow.goToNextWorkflowStep();
    }
  }
});
</script>
